"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "wf-component wf-component--select-party" };
const _hoisted_2 = {
    key: 0,
    class: "nofloat wf-component-title"
};
const _hoisted_3 = {
    key: 1,
    class: "wf-component--list-party"
};
const _hoisted_4 = ["value"];
const _hoisted_5 = {
    key: 2,
    class: "nofloat"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Party = (0, vue_1.resolveComponent)("Party");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.showtitle === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.turmoil !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.turmoil.parties, (party) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                        key: party.name
                    }, [
                        (_ctx.partyAvailableToSelect(party.name))
                            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("input", {
                                key: 0,
                                type: "radio",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedParty) = $event)),
                                value: party.name
                            }, null, 8, _hoisted_4)), [
                                [vue_1.vModelRadio, _ctx.selectedParty]
                            ])
                            : (0, vue_1.createCommentVNode)("", true),
                        (0, vue_1.createVNode)(_component_Party, {
                            party: party,
                            isDominant: _ctx.isDominant(party.name),
                            isAvailable: _ctx.partyAvailableToSelect(party.name)
                        }, null, 8, ["party", "isDominant", "isAvailable"])
                    ]));
                }), 128))
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.showsave === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [
                (0, vue_1.createVNode)(_component_AppButton, {
                    onClick: _ctx.saveData,
                    title: _ctx.playerinput.buttonLabel
                }, null, 8, ["onClick", "title"])
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
